import React from 'react';
import AppVars from '../../../AppVars.js';
import Logger from '../../../Logger.js';
import axios from 'axios';
import { finishPhoneAuthentication, parseCookies, validateSessionToken, isValidGoToURL } from 'account-portal-library/lib/helperFunctions'
import TOCreatePasswordFormView from '../../Views/TO/Register/Local/CreatePasswordFormView';
import { getGotoUrlFromCookies } from '../../../gotoUrl.js';
import navigateWithAnalytics from '../../../analytics/navigateWithAnalytics.js';
import pushAnalytics from '../../../analytics/pushAnalytics.js';
// import ResetSuccess from '../../Reset/ResetSuccess.js';

const appVars = AppVars.getInstance()
const logger = Logger.getInstance();

const UNKNOWN_ERROR_URL = "/unknownerror";
const INPUT_VALIDATION = {
    "PASSWORD": "^((?=.*[a-z])(?=.*[A-Z])(?=.*\\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])|(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z0-9])|(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]))([A-Za-z\\d@#$%^&*\\-_+=[\\]{}|\\\\:',?\\/`~\"();!]|\\.(?!@)){8,16}$"
}

const COMPONENT_TREE = [
    { component_name: 'Dealer', component_version: '1.0.0' },
    { component_name: 'CreatePassword', component_version: '1.0.0' }
];

class CreatePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            displayUsername: sessionStorage.AP_SSID,
            password: "",
            passwordMatch: "",
            showPassword: false,
            loading: false,
            isPasswordValid: null,
            isPasswordMatch: null,
            isPasswordUsed: null,
            isCPFormValid: null,
            responseCode: null,
            isResponseValid: null,
            passwordFocus: false,
            floatPassword: true,
            confirmPasswordFocus: false,
            // isPasswordUpdated: false,
            loginURI: null,
        };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handlePasswordMatchChange = this.handlePasswordMatchChange.bind(this);
        this.handleCPFormSubmit = this.handleCPFormSubmit.bind(this);
        this.setFocusPassword = this.setFocusPassword.bind(this);
        this.removeFocusPassword = this.removeFocusPassword.bind(this);
        this.setFocusConfirmPassword = this.setFocusConfirmPassword.bind(this);
        this.removeFocusConfirmPassword = this.removeFocusConfirmPassword.bind(this);
        this.showHidePassword = this.showHidePassword.bind(this);
        this.onBlurPassword = this.onBlurPassword.bind(this);
        this.sendJourneyPayload = this.sendJourneyPayload.bind(this);
    }

    componentDidMount() {
        if (this.props.signInType === "PHONE" || this.props.signInType === "OTP") {
            const username = sessionStorage.AP_SSID
            let displayPhone;
            try {
                displayPhone = "(" + username.substring(0, 3) + ") " + username.substring(3, 6) + "-" + username.substring(6, 10)
            } catch {
                displayPhone = username;
            }
            this.setState({ displayUsername: displayPhone })
        } else {
            this.setState({ displayUsername: this.props.username || sessionStorage.AP_SSID })
        }
    }

    async sendJourneyPayload(journeyPayload, url, headers, params) {
        try {
            const resp = await axios({ method: 'post', url, headers, params, data: journeyPayload });
            return {
                response: resp.data,
                status: resp.status
            };
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            return {
                response: data,
                status: status,
                failureUrl: status === 401 ? data?.failureUrl || UNKNOWN_ERROR_URL : UNKNOWN_ERROR_URL
            };
        }
    };

    async handleCPFormSubmit(event) {
        event.preventDefault();
        this.setState({ isPasswordUsed: false });
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
            const params = {
                'authIndexType': 'service',
                'authIndexValue': this.props.prevStep === "RESET" ? appVars.getMFATree() : appVars.getSignInTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=1.1',
                'Content-Type': 'application/json',
                ...(this.props.uid ? { 'x-username': this.props.uid } : {}),
            };
            const passwordPayload = { ...this.state.payload };
            if (passwordPayload?.callbacks?.[0]?.input?.[0]) {
                passwordPayload.callbacks[0].input[0].value = this.state.password;
            } else {
                // console.log("Invalid password payload structure");
                throw passwordPayload;
            }
            const journeyResponse = await this.sendJourneyPayload(passwordPayload, url, headers, params);
            // console.log(`Journey Response(${this.props.prevStep === "RESET" ? "Reset Password" : "Create Password"} Submit) -> `, journeyResponse);

            if (journeyResponse.status !== 200) {
                throw journeyResponse.response;
            }
            else if (journeyResponse.response["callbacks"] && journeyResponse.response?.callbacks[0].output[0].value === "password_history_failure") {
                this.setState({ loading: false, isPasswordUsed: true });
                pushAnalytics("sys-action", {
                    form_name: "create-password-form",
                    error_type: "password_history_failure",
                    metrics: 'km-form_field_submit-error',
                    displayed_error_message: "Password has been used previously.",
                }, COMPONENT_TREE);
            }
            else {
                this.setState({ payload: journeyResponse.response });
                this.handleSuccess(journeyResponse.response);
            }
        } catch (errorResponse) {
            this.setState({ isResponseValid: false })
            // console.log("Error -> ", errorResponse);
        }
    }

    async handleSuccess(journeyResponse) {
        const callbacks = journeyResponse?.callbacks;
        if (!callbacks || callbacks.length === 0) {
            const tokenValid = await this.checkToken(journeyResponse);
            // console.log("Token Valid -> ", tokenValid)
            if (tokenValid) {
                pushAnalytics('aa-action', { button_action: 'createPassword', ctaText: 'NEXT STEP', initiator: 'user', user_login_source: 'Email'}, COMPONENT_TREE, "Logged In")
                const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
                window.location.replace(gotoUrl);
            } else {
                // Token was invalid for a successful response
                window.location.replace(appVars.getUnknownErrorURL(this.props.style));
            }
        } else if (journeyResponse.callbacks[0].output[0].type === "TextOutputCallback") {
            const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
            navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
            return null;
        } else if (this.props.prevStep === "RESET") {
            alert("Your password has been updated successfully!");
            if (journeyResponse.callbacks[0].type === 'ChoiceCallback') {
                this.props.savePayload(journeyResponse);
                this.props.displayForm("TRUST");
            }
        }
        else {
            const tokenValid = await this.checkToken(journeyResponse);
            // console.log("Token Valid -> ", tokenValid)
            if (tokenValid) {
                const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
                navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
            } else {
                // Token was invalid for a successful response
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        }
    }

    async checkToken(journeyResponse) {
        try {
            const tokenId = journeyResponse.tokenId;
            // console.log("Token ID -> ", tokenId)
            if (tokenId != null) {
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                return validateResponse.response.valid;
            } else {
                return false
            }
        }
        catch {
            return false
        }
    }

    validateInput(inputValue, inputType) {
        const regex = RegExp(INPUT_VALIDATION[inputType])
        if (regex.test(inputValue)) {
            return true;
        }
        return false;
    }

    //Validates that password fulfills requirements
    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
        this.setState({ isPasswordValid: this.validateInput(event.target.value, "PASSWORD") })
    }

    //Validates that provided passwords match
    handlePasswordMatchChange(event) {
        this.setState({ passwordMatch: event.target.value });
        this.setState({ isPasswordMatch: (this.state.password === event.target.value) })
    }

    setFocusPassword(event) {
        this.setState({ passwordFocus: true })
        this.setState({ floatPassword: false })
    }

    removeFocusPassword() {
        this.setState({ passwordFocus: false })
    }

    onBlurPassword() {
        if (this.state.password === "") {
            this.setState({ floatPassword: true })
        } else {
            this.setState({ floatPassword: false })
        }
        this.removeFocusPassword()
        this.setState({ isPasswordValid: this.validateInput(this.state.password, "PASSWORD") })
    }

    setFocusConfirmPassword(event) {
        this.setState({ confirmPasswordFocus: true })
    }

    removeFocusConfirmPassword() {
        if (this.state.passwordMatch === "") {
            this.setState({ confirmPasswordFocus: false })
        } else {
            this.setState({ confirmPasswordFocus: true })
        }
    }

    showHidePassword() {
        this.setState({ showPassword: !this.state.showPassword })
    }

    render() {
        if (this.state.isPasswordValid === false) {
            pushAnalytics('sys-action', {
                form_name: 'create-password-form',
                field_name: 'password',
                error_type: 'validation',
                metrics: 'km-form_field_entry-error',
                displayed_error_message: 'Password requirements'
            }, COMPONENT_TREE);
        }

        if (this.state.isPasswordMatch === false) {
            pushAnalytics('sys-action', {
                form_name: 'create-password-form',
                field_name: 'confirm-password',
                error_type: 'validation',
                displayed_error_message: 'Your passwords do not match.',
                metrics: 'km-form_field_entry-error'
            }, COMPONENT_TREE);
        }
        // <ResetSuccess style={this.props.style} loginURI={this.state.loginURI} /> 
        return (
            <TOCreatePasswordFormView
                style={this.props.style}
                displayUsername={this.state.displayUsername}
                loading={this.state.loading}
                password={this.state.password}
                showPassword={this.state.showPassword}
                signInType={this.props.signInType}
                passwordMatch={this.state.passwordMatch}
                isPasswordValid={this.state.isPasswordValid}
                isPasswordMatch={this.state.isPasswordMatch}
                isCPFormValid={this.state.isCPFormValid}
                isResponseValid={this.state.isResponseValid}
                isPasswordUsed={this.state.isPasswordUsed}
                handlePasswordChange={this.handlePasswordChange}
                handlePasswordMatchChange={this.handlePasswordMatchChange}
                handleCPFormSubmit={this.handleCPFormSubmit}
                passwordFocus={this.state.passwordFocus}
                setFocusPassword={this.setFocusPassword}
                removeFocusPassword={this.removeFocusPassword}
                confirmPasswordFocus={this.state.confirmPasswordFocus}
                setFocusConfirmPassword={this.setFocusConfirmPassword}
                removeFocusConfirmPassword={this.removeFocusConfirmPassword}
                showHidePassword={this.showHidePassword}
                floatPassword={this.state.floatPassword}
                onBlurPassword={this.onBlurPassword}
                prevStep={this.props.prevStep}
            />
        )
    }
}

export default CreatePassword;